import React from "react";
import TableCell from "@material-ui/core/TableCell";
import classNames from "classnames";
import PropTypes from "prop-types";
import "./TableCellCustom.scss";

export const TableCellCustom = ({ className, align, verticalAlign, isContentWidth, children, ...restProps }) => (
    <TableCell
        align={align}
        className={classNames(
            "table-cell",
            { "table-cell--width-auto": isContentWidth },
            `table-cell--vertical-align-${verticalAlign}`,
            className
        )}
        {...restProps}
    >
        {children}
    </TableCell>
);

TableCellCustom.defaultProps = {
    verticalAlign: "middle",
    align: "left",
    isContentWidth: false,
    children: null
};

TableCellCustom.propTypes = {
    className: PropTypes.string,
    align: PropTypes.string,
    isContentWidth: PropTypes.bool,
    verticalAlign: PropTypes.string
};
